export type BuildEnv = 'dev' | 'staging' | 'prod';
export type EmbedValue = 'iframe' | 'alt' | 'script';
export type SrcMethod = 'module' | 'script';
export type ManifestType = 'dash' | 'hls';

export const MODE = {
  DEFAULT: 'default',
  LIVE: 'live',
} as const;
export type Mode = (typeof MODE)[keyof typeof MODE];

export type TestingAttributes = {
  seekTest?: boolean;
  seekCurrentInterval: number;
  seekIntervalId: Nullish<ReturnType<typeof setInterval>>;
  seekCurrentIntervalId: Nullish<ReturnType<typeof setInterval>>;
};

export type TestingQueryAttributes = {
  seekDuration: Nullish<number>;
  seekDurationMax: number;
  seekDurationMin: number;
};

export interface AttributeOptions {
  autoplay: boolean;
  background: boolean;
  bitrateLimitEnabled: boolean;
  callToActionButton: boolean;
  chunkedTransfer: boolean;
  controls: boolean;
  debug: boolean;
  encodedManifest: string | undefined;
  env: string;
  id: Nullish<string>;
  iframeId: Nullish<string>;
  isIos: boolean;
  loop: boolean;
  manifest: string | undefined;
  manifestType: ManifestType;
  mode: Mode;
  mute: boolean;
  playerProfileId: Nullish<string>;
  scrubBar: boolean;
  startPos: Nullish<number>;
  studio: string;
  type: string;
}
